import { inject, Injectable } from '@angular/core';
import { CanActivate, Router, UrlTree } from '@angular/router';
import { StudentService } from '@app/app.services';

@Injectable({
  providedIn: 'root',
})
export class LoginGuard implements CanActivate {
  studentService: StudentService = inject(StudentService);
  router: Router = inject(Router);

  canActivate(): boolean | UrlTree {
    // Check if user is logged in
    if (this.isLoggedIn()) {
      return this.router.parseUrl('/');
    }
    // Allow access to login page
    return true;
  }

  isLoggedIn(): boolean {
    const student = this.studentService?.student;
    return student && student?.remoteId !== 'GUEST';
  }
}
